import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { PixelDimensions2D } from '../../../../../features/lockers/models/pixel-dimensions-2d.model';

export type ModuleTileStylesProps = {
  pixelDimensions2D: PixelDimensions2D;
  maxModuleHeight: number;
};

export const useModuleTileStyles = makeStyles<Theme, ModuleTileStylesProps>({
  root: {},
  title: {
    fontSize: 14,
    fontWeight: 600,
    outline: '1px solid lightgrey',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '1px'
  },
  deliveryContainerTiles: {
    position: 'relative',
    height: ({ pixelDimensions2D }) => pixelDimensions2D.height,
    width: ({ pixelDimensions2D }) => pixelDimensions2D.width,
    // Bottom margin prevents the bottom of the module from being cut off
    marginBottom: '1px',
    outline: '1px solid lightgrey'
  }
});
